<template>
  <div>
    <Base :detail="detail.poultryLineCustomerInfo || {}" />
    <Customer :detail="detail.poultryLineCustomerInfo || {}" />
    <FeedInfo :detail="detail || {}" />
    <CustomerFeedback :detail="detail.poultryLineFeedback || {}" :detailUpload="detail"/>
  </div>
</template>

<script>
import api from './api'
import Base from './EggDetailComponents/Base.vue'
import Customer from './EggDetailComponents/Customer.vue'
import FeedInfo from './EggDetailComponents/FeedInfo.vue'
import CustomerFeedback from './EggDetailComponents/CustomerFeedback.vue'
export default {
  components: {Base,Customer,FeedInfo,CustomerFeedback},
  props: {},
  data() {
    return {
      src: require('@/assets/images/model/star.png'),
      detail: {
        createTime: '',
        createUser: '',
        feedList: [],
        feedStageList: [],
        imgArr: [],
        opinion: ''
      }
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.getDetail()
  },
  methods: {
    async getDetail(){
      let {id} = this.$route.query
      let params = {
        recordId: id,
        lineType: 'POULTRY_LINE_EGG'
      }
      let res = await api.pigDetail(params)
      this.detail = res?.data || {}
    },
  },
}
</script>
<style lang='scss'>
.componentBox{
  padding: 20px 0;
  background: #fff;
  margin: 20px;
  border-radius: 3px;
  box-shadow: 1px 1px 3px 1px rgba(0,0,0,0.1);
}
.componentTitle{
  font-weight: bold;
  color: #000;
  font-size: 16px;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
  padding-left: 20px;
}
.littleTitle{
  font-weight: bold;
  font-size: 14px;
  color: #333;
  padding-left: 20px;
  padding-bottom: 3px;
}
</style>
<style lang='scss' scoped></style>